import { MultiplicityPatterns } from './MultiplicityPatterns';
export const couplingPatterns = MultiplicityPatterns.map((m) => m.value);
//# sourceMappingURL=couplingPatterns.js.map